import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteArticlesFeaturedComponent} from './website-articles-featured.component'
import {BrowserModule} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {SharedModule} from '../shared/shared.module'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
import {CarouselModule} from 'ngx-owl-carousel-o'
import {WebsiteCarouselArticlesFeaturedModule} from '../website-carousel-articles-featured/website-carousel-articles-featured.module'
@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    SharedModule,
    NgbNavModule,
    CarouselModule,
    WebsiteCarouselArticlesFeaturedModule,
  ],
  declarations: [WebsiteArticlesFeaturedComponent],
  exports: [
    WebsiteArticlesFeaturedComponent
  ],
  providers: []
})
export class WebsiteArticlesFeaturedModule {
}
